import axios from "axios";
import lstModules from "common/json/lstModules.json"

var httpURLCommon = lstModules['timeTable'].url + ':' + lstModules['timeTable'].port
// var httpURLCommon = lstModules['local'].url + ':' + lstModules['local'].port

var screenId = 33;
var tokenId = localStorage.getItem('tokenid');

export const getEligibilityReportSvc = (cbListEligibilityResponse) => {
    var obj = { status: "Success", message: "" }
    // console.log(httpURLCommon + "/sms/tt/v1/tch/eligibility_report")
    axios({
        url: httpURLCommon + "/sms/tt/v1/tch/eligibility_report",
        method: "POST",
        headers: { 'tokenid': tokenId },
        withCredentials: true
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstEligibility = response.data.lstEligibility;
        cbListEligibilityResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbListEligibilityResponse(obj);
    })
}


export const uploadEligibilityExcelSvc = (eligibilityExcelFile, cbUploadEligibilityResponse) => {
    // console.log("uploadEligibilityExcel called, eligibilityExcelFile", eligibilityExcelFile);
    var obj = { status: "Success", message: "" }
    // console.log(httpURLCommon + "sms/syllabus/excel/upload/teacher_eligibility")
    const formData = new FormData();
    formData.append("eligibilityExcelFile", eligibilityExcelFile);
    axios({
        url: httpURLCommon + "/sms/syllabus/excel/upload/teacher_eligibility",
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenId },
        withCredentials: true
    }).then((response) => {
        // console.log("response in uploadEligibilityExcel", JSON.stringify(response, null, 2));
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        cbUploadEligibilityResponse(obj);
    }).catch((e) => {
        obj.status = "Exception";
        obj.message = e;
        cbUploadEligibilityResponse(obj);
    })
}

